import actions from './actions.js'
import getters from './getters.js'
import {state, mutations} from './mailHistoryMutation.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/mailHistoryModules/mailHistoryModule.js